import { getThemeColors } from "../../lib/theme";

interface TabButtonProps {
  active: boolean;
  onClick: () => void;
  isDark: boolean;
  theme: ReturnType<typeof getThemeColors>;
  children: React.ReactNode;
  className?: string;
  "data-testid"?: string;
}

export function TabButton({
  active,
  onClick,
  isDark,
  theme,
  children,
  className = "",
  "data-testid": dataTestId,
}: TabButtonProps) {
  return (
    <button
      onClick={onClick}
      data-testid={dataTestId}
      aria-pressed={active}
      className={`py-2 px-3 sm:px-4 rounded-lg text-sm font-display cursor-pointer transition-[transform,background-color] duration-150 ${
        active
          ? "bg-gold text-ink border-2 border-ink shadow-board-sm -translate-y-0.5"
          : `${theme.textMuted} border-2 border-transparent ${isDark ? "hover:text-white" : "hover:text-gray-900"}`
      } ${className}`}
    >
      {children}
    </button>
  );
}

interface TabGroupProps {
  children: React.ReactNode;
  className?: string;
  theme: ReturnType<typeof getThemeColors>;
}

export function TabGroup({ children, className = "", theme }: TabGroupProps) {
  return (
    <div
      className={`flex items-center gap-1 p-1.5 pb-2 rounded-xl ${theme.bgSecondary} border-[3px] border-ink ${className}`}
    >
      {children}
    </div>
  );
}
